// src/services/api/offlineSales/paymentMethods.js
import { apiClient } from '../base';

export const getPaymentMethods = () =>
  apiClient.get('/offline-sales/payment-methods').then(r => r.data);

export const getAllPaymentMethods = () =>
  apiClient.get('/offline-sales/payment-methods/all').then(r => r.data);

export const getPaymentMethodSettings = () =>
  apiClient.get('/offline-sales/payment-methods/settings').then(r => r.data);

export const updatePaymentMethodSettings = (data) =>
  apiClient.put('/offline-sales/payment-methods/settings', data).then(r => r.data);

export const assignPaymentMethod = (paymentMethodId) =>
  apiClient.post(`/offline-sales/payment-methods/${paymentMethodId}/assign`).then(r => r.data);

export const unassignPaymentMethod = (paymentMethodId) =>
  apiClient.delete(`/offline-sales/payment-methods/${paymentMethodId}/assign`).then(r => r.data);

export const updatePaymentMethod = (paymentMethodId, data) =>
  apiClient.put(`/offline-sales/payment-methods/${paymentMethodId}`, data).then(r => r.data);
